import { createApp } from 'vue'
import App from './App.vue'
import VueSignature from "vue-signature-pad";
import '@/assets/css/tailwind.css'
import router from './router'
/* import ToggleSwitch from 'vuejs-toggle-switch' */
/* import { VueSpinners } from '@saeris/vue-spinners' */
import vSelect from 'vue-select';
import Maska from 'maska'
import BootstrapVue3 from 'bootstrap-vue-3'
import {toCurrency, capitalizeWords} from '@/helpers/filters.js'
import Vue3Material from 'vue3-material';
import mdiVue from 'mdi-vue/v3'
import * as mdijs from '@mdi/js';
import "vue-select/dist/vue-select.css";
// Optional, since every component import their Bootstrap functionality
// the following line is not necessary
// import 'bootstrap'
import 'vue-material/dist/vue-material.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import LoginComponent from 'basic-forms-vue/src/Login';


const app = createApp(App)
        .use(router)
        .use(BootstrapVue3)
        .use(vSelect)
        .use(Maska)
        .use(VueSignature)
        .use(mdiVue, {icons: mdijs})
        .use(Vue3Material);
app.component('v-select', vSelect);
app.config.productionTip = false

app.mount('#app')
app.config.globalProperties.$filters = { toCurrency, capitalizeWords }

app.component('LoginComponent', LoginComponent);